import { apiService } from '.';
import { ISelect, ParamEnum } from '../shared/types/shared';

export const asyncGetParams = async (
    classParam?: ParamEnum,
    name?: string,
    page = 0,
    pageSize = 0,
    code?: string
): Promise<ISelect[]> => {
    try {
        const { items }: any = await apiService.get(`/api/param`, {
            class: classParam || '',
            name: name || '',
            code: code || '',
            limit: pageSize,
            page: page,
        });

        return items?.items || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetParamByCode = async (
    code: string
): Promise<ISelect | undefined> => {
    try {
        const { items }: any = await apiService.get(
            `/api/param/by-code/${code}`
        );
        return items;
    } catch (error) {}
};
